import React from "react";

const ParametresPage = () => {
  return <div>ParametresPage</div>;
};

export default ParametresPage;
